<template>
  <div class="routes py-3">
    <!-- Leyenda de símbolos del mapa -->
    <v-card class="mx-auto mb-3 pa-3" elevation="2" v-if="routes.length">
      <div class="d-flex flex-wrap justify-center align-center">
        <div class="legend-item mr-4 mb-2">
          <svg
            class="legend-icon"
            viewBox="-30 -30 60 60"
            width="28"
            height="28"
          >
            <path
              d="M 0,-24 L 7,-8 L 24,-8 L 10,3 L 16,19 L 0,9 L -16,19 L -10,3 L -24,-8 L -7,-8 Z"
              fill="#1E88E5"
              stroke="#fff"
              stroke-width="2"
            />
          </svg>
          <span class="legend-text">Completed</span>
        </div>
        <div class="legend-item mr-4 mb-2">
          <svg
            class="legend-icon"
            viewBox="-30 -30 60 60"
            width="28"
            height="28"
          >
            <path
              d="M -14,-14 L 14,-14 L 14,14 L -14,14 Z"
              fill="#1E88E5"
              stroke="#fff"
              stroke-width="2"
            />
          </svg>
          <span class="legend-text">Closed</span>
        </div>
        <div class="legend-item mr-4 mb-2">
          <svg
            class="legend-icon"
            viewBox="-30 -30 60 60"
            width="28"
            height="28"
          >
            <circle
              cx="0"
              cy="0"
              r="13"
              fill="#1E88E5"
              stroke="#fff"
              stroke-width="2"
            />
          </svg>
          <span class="legend-text">Pending</span>
        </div>
        <div class="legend-item mb-2">
          <svg
            class="legend-icon"
            viewBox="-30 -30 60 60"
            width="28"
            height="28"
          >
            <path
              d="M 0,-16 L 14,12 L -14,12 Z"
              fill="#1E88E5"
              stroke="#fff"
              stroke-width="2"
            />
          </svg>
          <span class="legend-text">On Route</span>
        </div>
      </div>
    </v-card>

    <div>
      <v-card class="mx-auto">
        <v-toolbar color="#E21A22" dark>
          <v-btn icon @click="prev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-calendar</v-icon>
              </v-btn>
            </template>
            <v-date-picker
              :value="date"
              color="red lighten-1"
              header-color="primary"
              @input="selectDate"
            ></v-date-picker>
          </v-menu>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{ dateFormat }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="next">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list three-line v-if="!routes.length">
          <template>
            <v-list-item-content>
              <v-list-item-title
                ><div class="px-5">{{ message }}</div></v-list-item-title
              >
            </v-list-item-content>
          </template>
        </v-list>
        <GmapMap
          ref="map"
          v-if="routes.length"
          :center="{ lat: 33.9190068, lng: -118.1200275 }"
          :position="google && new google.maps.LatLng(33.9190068, -118.1200275)"
          :zoom="14"
          :key="id"
          style="width: 100%; height: 400px"
          class="mx-auto"
        >
          <GmapMarker
            v-for="(m, i) in markers"
            :key="'marker-' + i"
            :position="m.position"
            :title="m.title"
            :icon="m.icon"
            :label="m.label"
            :clickable="true"
            @click="handleMarkerClick(m)"
          />
        </GmapMap>
        <v-expansion-panels
          v-if="routes.length"
          accordion
          :multiple="false"
          v-model="activePanel"
          @change="onPanelChange"
        >
          <v-expansion-panel
            v-for="(it, ind) in routes"
            :key="'rut-' + (it?.route ?? ind)"
          >
            <!-- HEADER AZUL -->
            <v-expansion-panel-header class="title white--text blue darken-1">
              {{ it.route }} - {{ it.driver }}
            </v-expansion-panel-header>

            <!-- CONTENIDO -->
            <v-expansion-panel-content>
              <!-- BOTONES -->
              <div class="mb-4 mt-2">
                <!-- Botón Create Manual Route (siempre arriba) -->
                <div class="mb-2">
                  <v-btn
                    color="success"
                    dark
                    @click="openCreateDialog(it)"
                    block
                  >
                    <v-icon left>mdi-plus</v-icon>
                    Create Manual Route
                  </v-btn>
                </div>

                <!-- Botón Save Current Order -->
                <div class="mb-2" v-if="canSaveCurrentOrder(it)">
                  <v-btn
                    color="primary"
                    dark
                    @click="saveCurrentOrder(it)"
                    block
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Save Current Order
                  </v-btn>
                </div>

                <div class="mb-2" v-if="$store.getters.driver_type === 'Manager' && it.customers && it.customers.length">
                  <v-btn color="primary" outlined block @click="saveCurrentOrder(it, true)">
                    <v-icon left>mdi-content-save-all</v-icon>
                    Save Order Permanently
                  </v-btn>
                  <small>Also applies to future occurrences of this recurring route. One-off visits stay date-specific.</small>
                </div>

                <!-- Botón Postpone Routes (abajo, solo si allId es true) -->
                <div class="mb-2" v-if="it.allId">
                  <v-btn
                    color="warning"
                    dark
                    @click="openPostponeDialog(it)"
                    block
                  >
                    <v-icon left>mdi-calendar-clock</v-icon>
                    Postpone Routes
                  </v-btn>
                </div>
              </div>

              <v-divider class="mb-3"></v-divider>

              <div
                v-for="(item, index) in it.customers"
                :key="`cust-${item.routeschedule_id || item.id}`"
              >
                <v-divider></v-divider>

                <v-list-item
                  @click="muestraRuta(ind, index)"
                  :class="'class' in item ? item.class : ''"
                >
                  <v-list-item-avatar color="#EA4335">
                    <span class="white--text headline text-center mx-auto">
                      {{ letters[index] ? letters[index] : "?" }}
                    </span>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>{{ item.businessName }} - {{ item.accountNumber }}</strong>
                      ({{ item.route }})
                    </v-list-item-title>

                    <v-list-item-subtitle v-if="item.temporarily_suspended">
                      <v-chip
                        x-small
                        color="orange"
                        text-color="white"
                      >Suspended</v-chip>
                    </v-list-item-subtitle>

                    <v-list-item-subtitle v-if="hasOneTimeNote(item)">
                      <v-chip x-small color="deep-purple" text-color="white">
                        One Time Note
                      </v-chip>
                    </v-list-item-subtitle>

                    <v-list-item-subtitle
                      v-html="item.serviceAddress"
                    ></v-list-item-subtitle>

                    <v-list-item-subtitle
                      v-html="item.contactPerson + ' - ' + item.phoneNumber"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action class="route-order-actions ma-0 mr-2">
                    <v-btn
                      icon
                      small
                      color="primary"
                      :disabled="index === 0"
                      @click.stop="moveCustomer(ind, index, -1)"
                    >
                      <v-icon small>mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="primary"
                      :disabled="index === it.customers.length - 1"
                      @click.stop="moveCustomer(ind, index, 1)"
                    >
                      <v-icon small>mdi-arrow-down</v-icon>
                    </v-btn>
                  </v-list-item-action>

                  <v-list-item-avatar color="green">
                    <span class="white--text headline text-center mx-auto">
                      {{ item.numContainers }}
                    </span>
                  </v-list-item-avatar>
                </v-list-item>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </div>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#1B6BAA">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ route.businessName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items> </v-toolbar-items>
          </v-toolbar>
          <GmapMap
            v-if="route"
            :center="center"
            :zoom="14"
            style="width: 100%; height: 400px"
            class="mx-auto"
          >
            <GmapMarker
              :key="'m-' + index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              @click="center = m.position"
            />
          </GmapMap>
          <v-card class="mb-10 elevation-5 mx-auto" outlined>
            <v-toolbar color="#E21A22" dark>
              <v-toolbar-title>Details</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div class="text-center mb-10">
                <p class="title">Modify Route</p>
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  :color="activeRoute == rin ? 'primary' : 'grey'"
                  v-for="(r, rin) in routes"
                  :key="'rin-' + rin"
                  @click="changeLetter(rin)"
                >
                  <span class="title">{{ r.route }}</span>
                </v-btn>
              </div>
              <div class="text-center mb-5">
                <v-btn
                  color="warning"
                  dark
                  @click="openPostponeIndividualDialog(route)"
                >
                  <v-icon left>mdi-calendar-clock</v-icon>
                  Postpone This Route
                </v-btn>
                <v-btn
                  v-if="canCancelRoute(route)"
                  color="error"
                  dark
                  class="mt-3"
                  @click="cancelIndividualRoute(route)"
                >
                  <v-icon left>mdi-cancel</v-icon>
                  Cancel This Route
                </v-btn>
              </div>
              <v-divider class="mb-3"></v-divider>
              <p><strong>Account number:</strong> {{ route.accountNumber }}</p>
              <p><strong>Route:</strong> {{ route.route }}</p>
              <p>
                <strong>Service address:</strong> {{ route.serviceAddress }}
              </p>
              <p>
                <strong>Days and hours of operation:</strong><br />
                <span
                  v-for="(dh, dhi) in route.daysAndHoursOfOperation"
                  :key="'dh-' + (dh?.id ?? dhi)"
                  >- {{ dh.name }}<br
                /></span>
              </p>
              <p>
                <strong>Containers at location:</strong><br />
                <span
                  v-for="(cn, cni) in route.containersAtLocation"
                  :key="'cn-' + (cn?.id ?? cni)"
                  >- {{ cn.container }}<br
                /></span>
              </p>
              <p><strong>E-mail:</strong> {{ route.email }}</p>
              <p><strong>Phone number:</strong> {{ route.phoneNumber }}</p>
              <p>
                <strong>Contact person at clinic:</strong>
                {{ route.contactPerson }}
              </p>
              <p><strong>Notes:</strong> {{ route.notes }}</p>
              <div class="mb-20"></div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-dialog>

      <!-- CREATE MANUAL ROUTE DIALOG -->
      <v-dialog
        v-model="dialogCreate"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="success">
            <v-btn icon @click="dialogCreate = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Add Manual Route</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text @click="saveManualRoute">SAVE</v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <!-- SEARCH SECTION -->
            <v-card outlined class="mb-4">
              <v-card-subtitle class="font-weight-bold blue--text">
                Search Customer
              </v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="manualRoute.customer_id"
                      :items="searchResults"
                      :loading="searchLoading"
                      :search-input.sync="searchQuery"
                      item-text="businessName"
                      item-value="id"
                      label="Search Business Name"
                      placeholder="Start typing to search..."
                      outlined
                      dense
                      clearable
                      no-filter
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.businessName
                          }}</v-list-item-title>
                          <v-list-item-subtitle
                            >{{ item.accountNumber }} -
                            {{ item.serviceAddress }}</v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </template>
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                searchQuery
                                  ? "No customers found"
                                  : "Start typing to search customers"
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- ROUTE DETAILS SECTION -->
            <v-card outlined class="mb-4">
              <v-card-subtitle class="font-weight-bold green--text">
                Route Details
              </v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="manualRoute.driver_id"
                      :items="manualRouteDrivers"
                      item-text="name"
                      item-value="id"
                      label="Driver"
                      outlined
                      dense
                      :disabled="!manualRouteDrivers.length"
                      :hint="
                        manualRouteDrivers.length
                          ? `${manualRouteDrivers.length} drivers available`
                          : 'No drivers available'
                      "
                      persistent-hint
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item && item.letter">
                          {{ item.letter }} - {{ item.name }}
                        </span>
                        <span v-else-if="item">
                          {{ item.name }}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span v-if="item.letter">
                              {{ item.letter }} - {{ item.name }}
                            </span>
                            <span v-else>
                              {{ item.name }}
                            </span>
                          </v-list-item-title>
                          <v-list-item-subtitle
                            v-if="item.active !== undefined"
                          >
                            Active: {{ item.active ? "Yes" : "No" }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="manualRoute.pickup_date"
                      label="Pick Up Date"
                      type="date"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model.number="manualRoute.order"
                      label="Order"
                      type="number"
                      outlined
                      dense
                      hint="Position in the route (1, 2, 3...)"
                      persistent-hint
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="manualRoute.contact_person_at_clinic"
                      label="Contact Person at Clinic"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-checkbox
              v-model="manualRoute.extraordinary_pickup"
              label="Extraordinary pickup — charge Express Service"
            />

            <!-- NOTES SECTION -->
            <v-card outlined>
              <v-card-subtitle class="font-weight-bold orange--text">
                Notes
              </v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="manualRoute.notes"
                      label="Notes"
                      outlined
                      rows="3"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea
                      v-model="manualRoute.notes_to_driver"
                      label="Notes to Driver"
                      outlined
                      rows="3"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- POSTPONE ROUTES DIALOG -->
      <v-dialog v-model="dialogPostpone" max-width="600px">
        <v-card>
          <v-toolbar dark color="warning">
            <v-toolbar-title
              >Postpone Routes - {{ selectedRoute.route }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogPostpone = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <p>
              <strong
                >All {{ selectedRoute.route }} routes will be postponed and
                reassigned</strong
              >
            </p>
            <v-alert dense outlined type="info" class="mb-4">
              <div class="font-weight-bold mb-1">
                Routes with One Time Notes: {{ selectedRouteOneTimeNotes.length }}
              </div>
              <div v-if="selectedRouteOneTimeNotes.length">
                <div
                  v-for="item in selectedRouteOneTimeNotes"
                  :key="`postpone-note-${item.routeschedule_id || item.id}`"
                  class="mb-2"
                >
                  <div>
                    <strong>{{ item.businessName }}</strong>
                    <span v-if="item.accountNumber">
                      - {{ item.accountNumber }}
                    </span>
                  </div>
                  <div>{{ item.notes_to_driver }}</div>
                </div>
              </div>
              <div v-else>No one-time notes found in selected route.</div>
            </v-alert>
            <v-text-field
              v-model="postponeData.newDate"
              label="New Date"
              type="date"
              outlined
              dense
            />
            <v-select
              v-model="postponeData.newDriver"
              :items="driversList"
              item-text="letter"
              item-value="letter"
              label="Select Driver"
              outlined
              dense
            >
              <template v-slot:selection="{ item }">
                {{ item.letter }} - {{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                {{ item.letter }} - {{ item.name }}
              </template>
            </v-select>
            <v-checkbox
              v-model="postponeData.permanent"
              label="Make it permanent"
            ></v-checkbox>
            <v-checkbox
              v-model="postponeData.includeExtras"
              label="Include extras"
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogPostpone = false"
              >Cancel</v-btn
            >
            <v-btn
              color="warning"
              @click="savePostpone"
              :disabled="!postponeData.newDate || !postponeData.newDriver"
            >
              Postpone
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- POSTPONE INDIVIDUAL ROUTE DIALOG -->
      <v-dialog v-model="dialogPostponeIndividual" max-width="600px">
        <v-card>
          <v-toolbar dark color="orange darken-2">
            <v-toolbar-title>Postpone Individual Route</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogPostponeIndividual = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <p>
              <strong>{{ postponeIndividualData.businessName }}</strong>
            </p>
            <p class="text-caption">
              Account: {{ postponeIndividualData.accountNumber }}
            </p>
            <v-alert dense outlined type="info" class="mb-4">
              <div class="font-weight-bold mb-1">Notes From Office</div>
              <div v-if="hasOneTimeNote(postponeIndividualData)">
                {{ postponeIndividualData.notes_to_driver }}
              </div>
              <div v-else>No one-time notes for this route.</div>
            </v-alert>
            <v-text-field
              v-model="postponeIndividualData.newDate"
              label="New Date"
              type="date"
              outlined
              dense
            />
            <v-select
              v-model="postponeIndividualData.newDriver"
              :items="driversList"
              item-text="letter"
              item-value="letter"
              label="Select Driver"
              outlined
              dense
            >
              <template v-slot:selection="{ item }">
                {{ item.letter }} - {{ item.name }}
              </template>
              <template v-slot:item="{ item }">
                {{ item.letter }} - {{ item.name }}
              </template>
            </v-select>
            <v-checkbox
              v-model="postponeIndividualData.permanent"
              label="Make it permanent"
            ></v-checkbox>
            <v-checkbox
              v-model="postponeIndividualData.includeExtras"
              label="Include extras"
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogPostponeIndividual = false"
              >Cancel</v-btn
            >
            <v-btn
              color="orange darken-2"
              dark
              @click="savePostponeIndividual"
              :disabled="
                !postponeIndividualData.newDate ||
                !postponeIndividualData.newDriver
              "
            >
              Postpone
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ROUTE INFO DIALOG (Al hacer click en marcador) -->
      <v-dialog v-model="dialogRouteInfo" max-width="600px" scrollable>
        <v-card v-if="selectedRouteInfo">
          <v-toolbar dark color="#1B6BAA">
            <v-toolbar-title>Route Information</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogRouteInfo = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-4">
            <!-- Business Name con status badge -->
            <div class="mb-3">
              <h2 class="text-h5 mb-2">{{ selectedRouteInfo.businessName }}</h2>
              <v-chip
                small
                :color="
                  selectedRouteInfo.status === 'Completed' ||
                  selectedRouteInfo.status === 'closed'
                    ? 'success'
                    : 'primary'
                "
                dark
                v-if="selectedRouteInfo.status"
              >
                {{ selectedRouteInfo.status }}
              </v-chip>
            </div>

            <v-divider class="mb-3"></v-divider>

            <!-- Información principal -->
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="mb-3">
                  <div class="text-caption grey--text">Account Number</div>
                  <div class="text-body-1">
                    {{ selectedRouteInfo.accountNumber }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="mb-3">
                  <div class="text-caption grey--text">Route</div>
                  <div class="text-body-1">{{ selectedRouteInfo.route }}</div>
                </div>
              </v-col>
            </v-row>

            <!-- Dirección -->
            <div class="mb-3">
              <div class="text-caption grey--text">Service Address</div>
              <div class="text-body-1">
                {{ selectedRouteInfo.serviceAddress }}
              </div>
            </div>

            <!-- Contacto -->
            <v-row dense>
              <v-col cols="12" sm="6">
                <div class="mb-3">
                  <div class="text-caption grey--text">Contact Person</div>
                  <div class="text-body-1">
                    {{ selectedRouteInfo.contactPerson || "N/A" }}
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="mb-3">
                  <div class="text-caption grey--text">Phone Number</div>
                  <div class="text-body-1">
                    {{ selectedRouteInfo.phoneNumber || "N/A" }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Email -->
            <div class="mb-3" v-if="selectedRouteInfo.email">
              <div class="text-caption grey--text">Email</div>
              <div class="text-body-1">{{ selectedRouteInfo.email }}</div>
            </div>

            <!-- Containers -->
            <div
              class="mb-3"
              v-if="
                selectedRouteInfo.containersAtLocation &&
                selectedRouteInfo.containersAtLocation.length
              "
            >
              <div class="text-caption grey--text mb-1">
                Containers at Location
              </div>
              <v-chip
                v-for="(cn, cni) in selectedRouteInfo.containersAtLocation"
                :key="'cn-info-' + (cn?.id ?? cni)"
                small
                class="mr-1 mb-1"
                color="green"
                text-color="white"
              >
                {{ cn.container }}
              </v-chip>
              <div class="text-caption mt-1">
                Total:
                {{
                  selectedRouteInfo.numContainers ||
                  selectedRouteInfo.containersAtLocation.length
                }}
              </div>
            </div>

            <!-- Horarios -->
            <div
              class="mb-3"
              v-if="
                selectedRouteInfo.daysAndHoursOfOperation &&
                selectedRouteInfo.daysAndHoursOfOperation.length
              "
            >
              <div class="text-caption grey--text mb-1">
                Days and Hours of Operation
              </div>
              <v-chip
                v-for="(dh, dhi) in selectedRouteInfo.daysAndHoursOfOperation"
                :key="'dh-info-' + (dh?.id ?? dhi)"
                small
                class="mr-1 mb-1"
                outlined
              >
                {{ dh.name }}
              </v-chip>
            </div>

            <!-- Notes -->
            <div class="mb-3" v-if="selectedRouteInfo.notes">
              <div class="text-caption grey--text">Notes</div>
              <div class="text-body-2">{{ selectedRouteInfo.notes }}</div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              v-if="canCancelRoute(selectedRouteInfo)"
              color="error"
              @click="cancelIndividualRoute(selectedRouteInfo)"
            >
              Cancel This Route
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogRouteInfo = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style scoped>
.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.legend-icon {
  display: block;
}
.legend-text {
  font-size: 14px;
  font-weight: 500;
  color: #424242;
}
.onroute {
  background: #e3f2fd;
}
.checkin {
  background: #bbdefb;
}
.extrasnotes {
  background: #90caf9;
}
.completed {
  background: #42a5f5;
}
.closed {
  background: #f44336;
}
</style>
<script>
import { gmapApi } from "vue2-google-maps";
export default {
  data: () => ({
    id: 0,
    routes: [],
    mapsLoaded: false,
    route: "",
    activeRoute: "",
    routeIndex: "",
    center: "",
    points: [],
    markers: [],
    message: "",
    dialog: false,
    dialogRouteInfo: false,
    selectedRouteInfo: null,
    allPolylines: [],
    directionsRenderer: null,
    mapMode: "all",
    activePanel: null,
    polyline: null,
    letters: [
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "X",
      "Y",
      "Z",
      "AA",
      "AB",
      "AC",
      "AD",
      "AE",
      "AF",
      "AG",
      "AH",
      "AI",
      "AJ",
      "AK",
      "AL",
      "AM",
      "AN",
      "AO",
      "AP",
      "AQ",
      "AR",
      "AS",
      "AT",
      "AU",
      "AV",
      "AW",
      "AX",
      "AY",
      "AZ",
    ],
    dateFormat: "",
    date: "",
    dateMenu: false,
    location: [],
    dialogCreate: false,
    dialogPostpone: false,
    dialogPostponeIndividual: false,
    selectedRoute: {},
    driversList: [],
    searchQuery: "",
    searchResults: [],
    searchLoading: false,
    searchTimeout: null,
    manualRoute: {
      extraordinary_pickup: false,
      customer_id: null,
      driver_id: null,
      pickup_date: "",
      contact_person_at_clinic: "",
      notes: "",
      notes_to_driver: "",
      order: 0,
      businessName: "",
      route: "",
    },
    postponeData: {
      newDate: "",
      newDriver: "",
      permanent: false,
      includeExtras: false,
    },
    postponeIndividualData: {
      routeschedule_id: null,
      customer_id: null,
      businessName: "",
      accountNumber: "",
      previousDate: "",
      previousDriver: "",
      notes: "",
      notes_to_driver: "",
      contactPersonAtClinic: "",
      order: 0,
      newDate: "",
      newDriver: "",
      permanent: false,
      includeExtras: false,
    },
  }),
  computed: {
    google: gmapApi,
    manualRouteDrivers() {
      // Route fallback data has no type, so it cannot establish eligibility.
      return this.driversList.filter(
        (driver) => driver.type !== undefined && driver.type !== "Manager",
      );
    },
    selectedRouteOneTimeNotes() {
      return this.routeOneTimeNotes(this.selectedRoute);
    },
  },
  watch: {
    date: function () {
      this.dateFormat = this.$moment(this.date).format("dddd, MMMM Do, YYYY");
    },
    searchQuery: function (val) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);

      if (!val || val.length < 2) {
        this.searchResults = [];
        return;
      }

      this.searchLoading = true;
      this.searchTimeout = setTimeout(() => {
        this.searchCustomers(val);
      }, 500);
    },
  },
  methods: {
    resetPostponeDialogs() {
      this.dialogPostpone = false;
      this.dialogPostponeIndividual = false;
      this.selectedRoute = {};
      this.postponeData = {
        newDate: "",
        newDriver: "",
        permanent: false,
        includeExtras: false,
      };
      this.postponeIndividualData = {
        routeschedule_id: null,
        customer_id: null,
        businessName: "",
        accountNumber: "",
        previousDate: "",
        previousDriver: "",
        notes: "",
        notes_to_driver: "",
        contactPersonAtClinic: "",
        order: 0,
        newDate: "",
        newDriver: "",
        permanent: false,
        includeExtras: false,
      };
    },
    canCancelRoute(route) {
      if (!route) {
        return false;
      }

      const status = route.status ? route.status.toLowerCase().trim() : "";

      return status === "" || status === "pending";
    },
    canSaveCurrentOrder(route) {
      return (
        route &&
        route.customers &&
        route.customers.length &&
        (!route.allId || route.orderChanged)
      );
    },
    hasOneTimeNote(route) {
      return !!(
        route &&
        route.notes_to_driver &&
        String(route.notes_to_driver).trim()
      );
    },
    routeOneTimeNotes(route) {
      if (!route || !route.customers) {
        return [];
      }

      return route.customers.filter((customer) => this.hasOneTimeNote(customer));
    },
    moveCustomer(routeIndex, customerIndex, direction) {
      const route = this.routes[routeIndex];

      if (!route || !route.customers) {
        return;
      }

      const newIndex = customerIndex + direction;
      if (newIndex < 0 || newIndex >= route.customers.length) {
        return;
      }

      const customer = route.customers.splice(customerIndex, 1)[0];
      route.customers.splice(newIndex, 0, customer);
      route.customers.forEach((item, index) => {
        this.$set(item, "order", index + 1);
      });
      this.$set(route, "orderChanged", true);

      if (this.activePanel === routeIndex) {
        this.$nextTick(() => {
          this.drawRouteOnMap(route);
        });
      }
    },
    apiErrorMessage(err) {
      return (
        err &&
        err.response &&
        err.response.data &&
        err.response.data.msg
      ) || "There was an error. Please try again.";
    },
    prev: function () {
      this.resetPostponeDialogs();
      this.date = this.$moment(this.date)
        .subtract(1, "day")
        .format("YYYY-MM-DD");
      this.show();
    },
    next: function () {
      this.resetPostponeDialogs();
      this.date = this.$moment(this.date).add(1, "day").format("YYYY-MM-DD");
      this.show();
    },
    selectDate(date) {
      this.dateMenu = false;
      this.date = date;
      this.show();
    },
    changeLetter: function (letter) {
      var este = this;
      var letra = este.routes[letter].route;
      console.log(letra);
      var datos = {};
      console.log(este.route);
      if (letter != este.activeRoute) {
        if (
          "routeschedule_id" in este.route &&
          este.route.routeschedule_id > 0
        ) {
          datos = {
            driver_id: este.$store.getters.driver_id,
            token: este.$store.getters.token,
            routeschedule_id: este.route.routeschedule_id,
            newLetter: letra,
          };
        } else {
          datos = {
            driver_id: este.$store.getters.driver_id,
            token: este.$store.getters.token,
            currentDriver: este.route.route,
            routeschedule_id: 0,
            customer_id: este.route.id,
            pickUpDate: este.date,
            location: este.route.location,
            newLetter: letra,
            notes: este.route.notes,
            notes_to_driver: este.route.notes_to_driver,
            contactPersonAtClinic: este.route.contactPerson,
          };
        }
        var laurl = "swapRoute";
        var mensaje = {};
        este.$http
          .post(este.$api + laurl, datos)
          .then(function (response) {
            if (response.status == 200 && response.data.status == "ok") {
              console.log("Swap Route Ready");
              window.console.log(response.status);
              mensaje = {
                color: "success",
                timeout: 5000,
                message: response.data.msg,
              };
              este.$store.commit("msgMuestra", mensaje);
              este.activeRoute = letter;
              este.show();
            } else {
              mensaje = {
                color: "red",
                timeout: 5000,
                message: response.data.msg,
              };
              este.$store.commit("msgMuestra", mensaje);
              if ("error" in response.data && response.data.error == "logout") {
                este.$router.push("/logout");
              }
            }
          })
          .catch(function (err) {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: este.apiErrorMessage(err),
            };
            este.$store.commit("msgMuestra", mensaje);
            window.console.log(err);
          });
      }
    },
    muestraRuta: function (index1, index2) {
      if (
        this.$moment(this.date).format("YYYY-MM-DD") >=
        this.$moment().format("YYYY-MM-DD")
      ) {
        console.log(this.date);
        console.log(index1, index2);
        this.activeRoute = index1;
        this.route = this.routes[index1].customers[index2];
        this.routeIndex = index2;
        console.log(this.route);
        this.markers = [
          {
            position: {
              lat: parseFloat(this.route.location[0].lat),
              lng: parseFloat(this.route.location[0].lng),
            },
            title: this.route.businessName,
          },
        ];
        var este = this;
        este.points[index2] = {
          location:
            parseFloat(este.route.location[0].lat) +
            "," +
            parseFloat(este.route.location[0].lng),
          stopover: true,
        };
        this.center = {
          lat: parseFloat(este.route.location[0].lat),
          lng: parseFloat(este.route.location[0].lng),
        };
        console.log(this.center);
        this.realStep = 1;
        if ("status" in this.route) {
          switch (this.route.status) {
            case "On Route":
              this.e1 = 2;
              break;
            case "Check In":
              this.e1 = 3;
              break;
            case "Extras / Notes":
              this.e1 = 4;
              break;
            case "Completed":
              this.e1 = 5;
              break;
            default:
              this.e1 = 1;
              break;
          }
        } else {
          this.e1 = 1;
        }
        this.dialog = true;
      }
    },
    show: function () {
      var este = this;
      este.resetPostponeDialogs();
      este.$http
        .post(este.$api + "routes", {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          date: este.date,
          isManager: 1,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            console.log("IMPRIME DATOS");
            window.console.log(response.status);
            if (!response.data.results) {
              este.message = response.data.msg;
              este.routes = [];
            } else {
              este.routes = response.data.data;
              este.id = response.data.id;
              este.optimizeRoute(
                response.data.data.filter((item) => item.customers.length > 0),
              );
              este.$nextTick(() => {
                este.drawDefaultMap();
                este.resizeMap();
              });
            }
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg,
            };
            este.routes = [];
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
          // Load drivers list after loading routes
          este.loadDriversList();
        })
        .catch(function (err) {
          este.routes = [];
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
    optimizeRoute: function (route) {
      var este = this;
      este.routes = route;
      este.$nextTick(() => {
        if (este.$refs.map) {
          route.forEach((item, index) => {
            este.initMap(item, index);
          });
        }
      });
    },
    initMap: function (route, routeIndex) {
      var este = this;
      este.$refs.map.$mapPromise.then((map) => {
        console.log(map);
        var google = this.google;
        var directionsDisplay = new google.maps.DirectionsRenderer();
        console.log(directionsDisplay);
        var points = [];
        route.customers.forEach(function (item, index) {
          points[index] = {
            location: item.location[0].lat + "," + item.location[0].lng,
            stopover: true,
          };
        });
        console.log(points);
        var optimizeWaypoints = false;
        if (route.manualorder > 0) {
          optimizeWaypoints = false;
        }
        console.log("PUNTOS");
        console.log(points);

        console.log("OPTIMIZA: ");
        console.log(optimizeWaypoints);
        if (points.length <= 25) {
          console.log("MENOS DE 25");
          if (optimizeWaypoints) {
            try {
              console.log("OPTIMIZANDO");
              if (este.routes[routeIndex].customers.length > 0) {
                este.routes[routeIndex].customers.sort((a, b) =>
                  a.order > b.order ? 1 : -1,
                );
              }
              console.log("ORDENANDO");
            } catch (e) {
              console.log("Error al ordenar: " + e);
            }
          } else {
            try {
              console.log("NO OPTIMIZANDO");
              if (este.routes[routeIndex].customers.length > 0) {
                este.routes[routeIndex].customers.sort((a, b) =>
                  a.order > b.order ? 1 : -1,
                );
              }
              console.log("ORDENANDO");
            } catch (e) {
              console.log("Error al ordenar: " + e);
            }
          }
        } else {
          console.log("MAS DE 25");
          if (optimizeWaypoints) {
            try {
              if (este.routes[routeIndex].customers.length > 0) {
                este.routes[routeIndex].customers.sort((a, b) =>
                  a.order > b.order ? 1 : -1,
                );
              }
            } catch (e) {
              console.log("Error al ordenar: " + e);
            }
          } else {
            try {
              if (este.routes[routeIndex].customers.length > 0) {
                este.routes[routeIndex].customers.sort((a, b) =>
                  a.order > b.order ? 1 : -1,
                );
              }
            } catch (e) {
              console.log("Error al ordenar: " + e);
            }
          }
        }
      });
    },
    onPanelChange(index) {
      if (index === undefined || index === null) {
        this.activePanel = null;

        this.$nextTick(() => {
          this.drawDefaultMap();
          this.resizeMap();
        });
        return;
      }

      this.$nextTick(() => {
        this.drawRouteOnMap(this.routes[index]);
        this.resizeMap();
      });
    },
    drawDefaultMap() {
      this.$refs.map.$mapPromise.then((map) => {
        if (!this.google) return;

        const google = this.google;

        // Limpia todo
        this.markers = [];

        if (this.polyline) {
          this.polyline.setMap(null);
          this.polyline = null;
        }

        this.allPolylines.forEach((p) => p.setMap(null));
        this.allPolylines = [];

        const bounds = new google.maps.LatLngBounds();

        const colors = [
          "#1E88E5",
          "#E53935",
          "#43A047",
          "#FB8C00",
          "#8E24AA",
          "#00ACC1",
        ];

        // Paths SVG para diferentes símbolos - todos proporcionales
        const starPath =
          "M 0,-24 L 7,-8 L 24,-8 L 10,3 L 16,19 L 0,9 L -16,19 L -10,3 L -24,-8 L -7,-8 Z";
        const squarePath = "M -14,-14 L 14,-14 L 14,14 L -14,14 Z";
        const trianglePath = "M 0,-16 L 14,12 L -14,12 Z";

        this.routes.forEach((route, rIndex) => {
          const markerColor = colors[rIndex % colors.length];

          route.customers.forEach((cust, custIndex) => {
            if (!cust.location || !cust.location.length) return;

            // Determinar el símbolo según el estado
            const status = cust.status ? cust.status.toLowerCase().trim() : "";
            let markerPath;
            let markerScale;
            let statusLabel = "";

            if (status === "completed") {
              markerPath = starPath; // ⭐ Estrella
              markerScale = 1;
              statusLabel = " ✓ COMPLETED";
            } else if (status === "closed") {
              markerPath = squarePath; // ⬛ Cuadrado
              markerScale = 1;
              statusLabel = " ✕ CLOSED";
            } else if (status === "pending" || status === "") {
              // Sin estatus O pending = círculo
              markerPath = google.maps.SymbolPath.CIRCLE; // ⚫ Círculo
              markerScale = 13;
              statusLabel = "";
            } else {
              // Otros estados: On Route, Check In, Extras/Notes, etc.
              markerPath = trianglePath; // 🔺 Triángulo
              markerScale = 1;
              statusLabel = status ? ` • ${status.toUpperCase()}` : "";
            }

            console.log(
              `${route.route} - ${cust.businessName}: ${
                cust.status || "SIN ESTATUS"
              } → ${
                status === "completed"
                  ? "⭐ ESTRELLA"
                  : status === "closed"
                  ? "⬛ CUADRADO"
                  : status === "pending" || status === ""
                  ? "⚫ CÍRCULO"
                  : "🔺 TRIÁNGULO"
              }`,
            );

            const pos = new google.maps.LatLng(
              parseFloat(cust.location[0].lat),
              parseFloat(cust.location[0].lng),
            );

            this.markers.push({
              position: { lat: pos.lat(), lng: pos.lng() },
              title: `${route.route} - ${cust.businessName}${statusLabel}`,
              label: {
                text: route.route, // ← A, B, C…
                color: "white",
                fontSize: "12px",
                fontWeight: "bold",
              },
              icon: {
                path: markerPath,
                scale: markerScale,
                fillColor: markerColor,
                fillOpacity: 1,
                strokeColor: "#fff",
                strokeWeight: 2,
              },
              // Información adicional para el click
              routeIndex: rIndex,
              customerIndex: custIndex,
              customerData: cust,
            });

            bounds.extend(pos);
          });
        });

        if (!bounds.isEmpty()) {
          map.fitBounds(bounds);
        }

        this.mapMode = "all";
      });
    },
    drawRouteOnMap(route) {
      this.$refs.map.$mapPromise.then((map) => {
        if (!this.google) return;

        const google = this.google;

        // Limpia markers
        this.markers = [];

        // Limpia rutas previas
        if (this.directionsRenderer) {
          this.directionsRenderer.setMap(null);
          this.directionsRenderer = null;
        }

        const bounds = new google.maps.LatLngBounds();

        // Armar puntos
        const points = route.customers
          .filter((c) => c.location && c.location.length)
          .map((c) => ({
            lat: parseFloat(c.location[0].lat),
            lng: parseFloat(c.location[0].lng),
            title: c.businessName,
          }));

        if (points.length < 2) return;

        // Markers (letras)
        points.forEach((p, i) => {
          this.markers.push({
            position: { lat: p.lat, lng: p.lng },
            title: p.title,
            label: {
              text: this.letters[i] || "",
              color: "white",
              fontWeight: "bold",
            },
          });

          bounds.extend(new google.maps.LatLng(p.lat, p.lng));
        });

        map.fitBounds(bounds);

        // DIRECTIONS API
        const directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer({
          suppressMarkers: true,
          polylineOptions: {
            strokeColor: "#1E88E5",
            strokeWeight: 5,
          },
        });

        this.directionsRenderer.setMap(map);

        const origin = points[0];
        const destination = points[points.length - 1];

        const waypoints = points.slice(1, -1).map((p) => ({
          location: new google.maps.LatLng(p.lat, p.lng),
          stopover: true,
        }));

        // Google solo permite 25 puntos
        if (points.length > 25) {
          console.warn("Más de 25 puntos, no se puede trazar la ruta completa");
          return;
        }

        directionsService.route(
          {
            origin,
            destination,
            waypoints,
            travelMode: google.maps.TravelMode.DRIVING,
            optimizeWaypoints: false,
          },
          (result, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
              this.directionsRenderer.setDirections(result);
            } else {
              console.error("Directions error:", status);
            }
          },
        );
      });
    },
    resizeMap() {
      this.$refs.map.$mapPromise.then((map) => {
        this.google.maps.event.trigger(map, "resize");
      });
    },
    isRouteComplete() {
      // Este método ya no se usa, pero lo mantenemos por compatibilidad
      // Ahora verificamos cada parada individualmente en drawDefaultMap()
      return false;
    },
    handleMarkerClick(marker) {
      console.log("Marker clicked, data:", marker);

      // Solo permitir click si hay información del marcador
      if (
        marker.routeIndex === undefined ||
        marker.customerIndex === undefined
      ) {
        console.log("Missing route or customer index");
        return;
      }

      const routeIndex = marker.routeIndex;
      const customerIndex = marker.customerIndex;

      console.log("Route index:", routeIndex, "Customer index:", customerIndex);

      // Guardar la información de la ruta seleccionada
      this.selectedRouteInfo = this.routes[routeIndex].customers[customerIndex];
      this.activeRoute = routeIndex;
      this.routeIndex = customerIndex;

      console.log("Route data:", this.selectedRouteInfo);

      // Abrir el diálogo de información
      this.dialogRouteInfo = true;
    },
    openCreateDialog(route) {
      this.selectedRoute = route;
      this.manualRoute = {
        extraordinary_pickup: false,
        customer_id: null,
        driver_id: null,
        pickup_date: this.date,
        contact_person_at_clinic: "",
        notes: "",
        notes_to_driver: "",
        order: 0,
        businessName: "Select from customers list",
        route: route.route,
      };
      this.dialogCreate = true;
    },
    openPostponeDialog(route) {
      this.selectedRoute = route;
      this.postponeData = {
        newDate: "",
        newDriver: "",
        permanent: false,
        includeExtras: false,
      };
      this.dialogPostpone = true;
    },
    openPostponeFromInfo() {
      // Cerrar el diálogo de info y abrir el de postpone individual
      this.dialogRouteInfo = false;
      this.openPostponeIndividualDialog(this.selectedRouteInfo);
    },
    viewFullDetails() {
      // Cerrar el diálogo de info y abrir el diálogo completo
      this.dialogRouteInfo = false;

      // Configurar igual que muestraRuta
      this.route = this.selectedRouteInfo;

      this.markers = [
        {
          position: {
            lat: parseFloat(this.route.location[0].lat),
            lng: parseFloat(this.route.location[0].lng),
          },
          title: this.route.businessName,
        },
      ];

      this.center = {
        lat: parseFloat(this.route.location[0].lat),
        lng: parseFloat(this.route.location[0].lng),
      };

      if ("status" in this.route) {
        switch (this.route.status) {
          case "On Route":
            this.e1 = 2;
            break;
          case "Check In":
            this.e1 = 3;
            break;
          case "Extras / Notes":
            this.e1 = 4;
            break;
          case "Completed":
            this.e1 = 5;
            break;
          default:
            this.e1 = 1;
            break;
        }
      } else {
        this.e1 = 1;
      }

      this.dialog = true;
    },
    saveManualRoute() {
      var este = this;
      var mensaje; // Declarar una sola vez

      // Validar campos requeridos
      if (!este.manualRoute.customer_id) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please select a customer",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      if (!este.manualRoute.driver_id) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please select a driver",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      // Asegurar que driver_id sea numérico
      var routeDriverId = parseInt(este.manualRoute.driver_id);
      if (isNaN(routeDriverId)) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Invalid driver selection",
        };
        este.$store.commit("msgMuestra", mensaje);
        console.error("driver_id is not a number:", este.manualRoute.driver_id);
        return;
      }

      if (!este.manualRoute.pickup_date) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please select a pickup date",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      if (
        este.manualRoute.order === null ||
        este.manualRoute.order === undefined ||
        este.manualRoute.order < 0
      ) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please enter a valid order number",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      // Enviar al API
      este.$http
        .post(este.$api + "addManualRoute", {
          driver_id: este.$store.getters.driver_id, // Driver logueado (para validar token)
          token: este.$store.getters.token,
          customer_id: este.manualRoute.customer_id,
          route_driver_id: routeDriverId, // Driver al que se asigna la ruta (ya validado como número)
          pickup_date: este.manualRoute.pickup_date,
          order: este.manualRoute.order,
          extraordinary_pickup: este.manualRoute.extraordinary_pickup,
          notes: este.manualRoute.notes,
          notes_to_driver: este.manualRoute.notes_to_driver,
          contact_person_at_clinic: este.manualRoute.contact_person_at_clinic,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            mensaje = {
              color: "success",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            este.dialogCreate = false;
            este.show(); // Recargar rutas
          } else {
            mensaje = {
              color: "error",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          mensaje = {
            color: "error",
            timeout: 5000,
            message: (err.response && err.response.data && (err.response.data.msg || err.response.data.message)) || "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          console.log(err);
        });
    },
    saveCurrentOrder(route, permanent = false) {
      var este = this;
      var mensaje;
      console.log("Saving current order for route:", route.route);

      // Preparar datos de las rutas con su orden actual
      var routes = [];
      route.customers.forEach(function (customer, index) {
        let routeData = {
          customer_id: customer.id,
          business_name: customer.businessName,
          order: index + 1, // El orden basado en la posición en el array
          driver_id: customer.driver_id,
          pickup_date: este.date,
          notes: customer.notes || "",
          notes_to_driver: customer.notes_to_driver || "",
          contact_person: customer.contactPerson || "",
        };

        if (customer.routeschedule_id) {
          routeData.routeschedule_id = customer.routeschedule_id;
        }

        routes.push(routeData);
      });

      // Enviar al API
      este.$http
        .post(este.$api + "saveOrder", {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          route: route.route,
          permanent: permanent,
          routes: routes,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            mensaje = {
              color: "success",
              timeout: 5000,
              message: response.data.msg || "Route order saved successfully",
            };
            este.$store.commit("msgMuestra", mensaje);
            este.$set(route, "orderChanged", false);
            // Recargar las rutas para actualizar allId
            este.show();
          } else {
            mensaje = {
              color: "error",
              timeout: 5000,
              message: response.data.msg || "There was an error",
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          mensaje = {
            color: "error",
            timeout: 5000,
            message: (err.response && err.response.data && err.response.data.msg) || "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          console.log(err);
        });
    },
    savePostpone() {
      var este = this;
      var mensaje;
      console.log("Postpone Data:", {
        route: este.selectedRoute.route,
        ...este.postponeData,
      });

      // Validar campos requeridos
      if (!este.postponeData.newDate) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please select a new date",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      if (!este.postponeData.newDriver) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please select a driver",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      // Buscar el driver_id por la letra
      var selectedDriverObj = este.driversList.find(
        (d) => d.letter === este.postponeData.newDriver,
      );
      if (!selectedDriverObj || !selectedDriverObj.id) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Invalid driver selection",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      // Recopilar todos los routeschedule_ids de la ruta seleccionada
      var links = [];
      este.selectedRoute.customers.forEach(function (customer) {
        if (customer.routeschedule_id) {
          links.push(customer.routeschedule_id);
        }
      });

      if (links.length === 0 || links.length !== este.selectedRoute.customers.length) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Save the current order for all selected visits before postponing the route.",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      // Enviar al API
      este.$http
        .post(este.$api + "batchPostpone", {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          newDate: este.postponeData.newDate,
          newDriver: selectedDriverObj.id,
          links: links,
          previousDate: este.date,
          previousDriver: este.selectedRoute.route,
          permanentPostpone: este.postponeData.permanent ? "true" : "false",
          extrasPostpone: este.postponeData.includeExtras ? "true" : "false",
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            mensaje = {
              color: "success",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            este.dialogPostpone = false;
            este.show(); // Recargar rutas
          } else {
            mensaje = {
              color: "error",
              timeout: 5000,
              message: response.data.msg || "There was an error",
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          mensaje = {
            color: "error",
            timeout: 5000,
            message: este.apiErrorMessage(err),
          };
          este.$store.commit("msgMuestra", mensaje);
          console.log(err);
        });
    },
    loadDriversList() {
      var este = this;
      console.log("Loading all drivers...");
      // Cargar TODOS los drivers disponibles desde el API
      este.$http
        .post(este.$api + "allDrivers", {})
        .then(function (response) {
          console.log("allDrivers response:", response);
          if (response.status == 200 && response.data.status == "ok") {
            // Asegurar que cada driver tenga un ID numérico
            este.driversList = response.data.data.map((d) => ({
              id: parseInt(d.id),
              name: d.name,
              letter: d.letter,
              type: d.type,
            }));
            console.log(
              "Loaded",
              este.driversList.length,
              "drivers:",
              este.driversList,
            );
          } else {
            console.log("Error loading all drivers:", response.data.msg);
            // Fallback: usar drivers de las rutas actuales
            este.driversList = este.routes.map((r) => ({
              id: parseInt(r.driver_id),
              name: r.driver,
              letter: r.route,
            }));
            console.log("Using fallback drivers:", este.driversList);
          }
        })
        .catch(function (err) {
          console.log("Error loading drivers:", err);
          // Fallback: usar drivers de las rutas actuales
          este.driversList = este.routes.map((r) => ({
            id: parseInt(r.driver_id),
            name: r.driver,
            letter: r.route,
          }));
          console.log("Using fallback drivers (catch):", este.driversList);
        });
    },
    searchCustomers(query) {
      var este = this;
      este.$http
        .post(este.$api + "customers/search", {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          query: query,
        })
        .then(function (response) {
          este.searchLoading = false;
          if (response.status == 200 && response.data.status == "ok") {
            este.searchResults = response.data.data;
          } else {
            este.searchResults = [];
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          este.searchLoading = false;
          este.searchResults = [];
          console.log("Error searching customers:", err);
        });
    },
    openPostponeIndividualDialog(route) {
      this.postponeIndividualData = {
        routeschedule_id: route.routeschedule_id || null,
        customer_id: route.id,
        businessName: route.businessName,
        accountNumber: route.accountNumber,
        previousDate: this.date,
        previousDriver: route.route,
        notes: route.notes || "",
        notes_to_driver: route.notes_to_driver || "",
        contactPersonAtClinic: route.contactPerson || "",
        order: route.order || 0,
        newDate: "",
        newDriver: "",
        permanent: false,
        includeExtras: false,
      };
      this.dialogPostponeIndividual = true;
    },
    cancelIndividualRoute(route) {
      var este = this;
      var mensaje;

      if (!este.canCancelRoute(route)) {
        return;
      }

      if (!window.confirm("Are you sure you want to cancel this route for this date?")) {
        return;
      }

      var datos = {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
        routeschedule_id: route.routeschedule_id || null,
        customer_id: route.id,
        previousDate: este.date,
        previousDriver: route.route,
        notes: route.notes || "",
        contactPersonAtClinic: route.contactPerson || "",
      };

      este.$http
        .post(este.$api + "cancelIndividualRoute", datos)
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            mensaje = {
              color: "success",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            este.dialog = false;
            este.dialogRouteInfo = false;
            este.show();
          } else {
            mensaje = {
              color: "error",
              timeout: 5000,
              message: response.data.msg || "There was an error",
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          mensaje = {
            color: "error",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          console.log(err);
        });
    },
    savePostponeIndividual() {
      var este = this;
      var mensaje;
      console.log("Postpone Individual Data:", este.postponeIndividualData);

      // Validar campos requeridos
      if (!este.postponeIndividualData.newDate) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please select a new date",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      if (!este.postponeIndividualData.newDriver) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Please select a driver",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      // Buscar el driver_id por la letra
      var selectedDriverObj = este.driversList.find(
        (d) => d.letter === este.postponeIndividualData.newDriver,
      );
      if (!selectedDriverObj || !selectedDriverObj.id) {
        mensaje = {
          color: "error",
          timeout: 5000,
          message: "Invalid driver selection",
        };
        este.$store.commit("msgMuestra", mensaje);
        return;
      }

      var datos = {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
        routeschedule_id: este.postponeIndividualData.routeschedule_id,
        customer_id: este.postponeIndividualData.customer_id,
        previousDate: este.postponeIndividualData.previousDate,
        previousDriver: este.postponeIndividualData.previousDriver,
        notes: este.postponeIndividualData.notes,
        notes_to_driver: este.postponeIndividualData.notes_to_driver,
        contactPersonAtClinic: este.postponeIndividualData.contactPersonAtClinic,
        order: este.postponeIndividualData.order,
        newDate: este.postponeIndividualData.newDate,
        newDriver: selectedDriverObj.id,
        permanentPostpone: este.postponeIndividualData.permanent
          ? "true"
          : "false",
        extrasPostpone: este.postponeIndividualData.includeExtras
          ? "true"
          : "false",
      };

      este.$http
        .post(este.$api + "postponeIndividualRoute", datos)
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            mensaje = {
              color: "success",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            este.dialogPostponeIndividual = false;
            este.show();
          } else {
            mensaje = {
              color: "error",
              timeout: 5000,
              message: response.data.msg || "There was an error",
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          mensaje = {
            color: "error",
            timeout: 5000,
            message: este.apiErrorMessage(err),
          };
          este.$store.commit("msgMuestra", mensaje);
          console.log(err);
        });
    },
  },
  mounted: function () {
    this.date = this.$moment().format("YYYY-MM-DD");
    this.$store.commit("title", "Modify Routes");
    if (!this.$store.getters.token || !this.$store.getters.driver_id) {
      this.$router.push("/login");
    } else {
      this.show();
    }
  },
};
</script>

<style scoped>
.route-order-actions {
  display: flex;
  flex-direction: column;
}
</style>
